/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
/* eslint-disable spaced-comment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import LabelsPicker from "../../../../Common/components/Inputs/LabelsPicker/LabelsPicker/LabelsPicker";
import prettyPrint from "../../../../Retrofit/utils/CorrespondingCrossComponent/prettyPrint";
import {
  clearBundlesToCompare,
  selectFiltersInit,
  selectFiltersWrapperOpened,
  selectGearboxSynchronizedFilters,
  selectPossibleFiltersValues,
  showSnackbar,
  setAxisFilters,
} from "../../../../Retrofit/store/slices/retrofit";
import Button from "../../../../Common/components/Buttons/Button/Button";
import Spinner from "../../../../Common/components/Icons/Spinner/Spinner";
import t from "../../../../Common/utils/translation/translator";
import { tData } from "../../../../Common/utils/translation/dataUtils";
import SelectionRange from "../../../../Common/components/Inputs/SelectionRange/SelectionRange";
import MotorFilters from "./MotorFilters";
import { selectIntegratedDrivesConfiguration } from "../../../../IntegratedDrives/store/slices/integrated_drives";
import { selectSelectedAxis } from "../../../../Cartesian/store/slices/cartesian";
import { useUpdateEffect } from "react-use";
import { syncDataElementWithSynchronizedFiltersElement } from "../../../utils/func.util";

const GearboxFilters = ({ closeTab, filters, axisId, refetchBundles, updateGearboxFilters, isLoading, ...props }) => {
  const possibleGearboxFiltersValues = useSelector(selectPossibleFiltersValues)?.gearbox;
  const integratedDrivesConfiguration = useSelector(selectIntegratedDrivesConfiguration);
  const synchronizedGearboxFilters = useSelector(selectGearboxSynchronizedFilters);
  const filtersWrapperOpened = useSelector(selectFiltersWrapperOpened);
  const filtersInit = useSelector(selectFiltersInit);
  const dispatch = useDispatch();

  const isIntegratedDrivesConfiguration = integratedDrivesConfiguration !== null;
  
  const [data, setData] = useState(filters?.gearboxFilter);
  const motorFilters = useState(filters?.motorFilter);
  const [withGearbox, setWithGearbox] = useState(motorFilters?.withGearbox || data?.enabled);
  const [highlightErrors, setHighlightErrors] = useState(false);

  const handleApplyFilters = () => {
    if (withGearbox && (!data?.productOrComponentType || data?.productOrComponentType?.length === 0)) {
      setHighlightErrors(true);
      dispatch(showSnackbar({ id: "MANDATORY_FIELDS" }));
      return;
    }
    // filters of the current axis
    const newFilters = {
      ...filters,
      gearboxFilter: data
    };
    // onApplyFilters(axisId, newFilters); 
    dispatch(setAxisFilters({ axisId, filters: newFilters }))
    dispatch(clearBundlesToCompare());
    refetchBundles();
    closeTab();
  };

  const getCartesianAxisSize = () => {
    const selectedAxis = useSelector(selectSelectedAxis);
    const axisSize = selectedAxis?.axis?.axisSize;
    return axisSize;
}


  const handleClearFilters = () => {
    // console.log("clear gearbox filters");
    const newFilters = {
      ...filters,
      gearboxFilter: {
        ...filtersInit.gearboxFilter,
        enabled: true ,
        family: undefined,
      ratio: [],
      externalDiameter: [],
      torsionalBacklash: {
        min: 0,
        max: Math.max(...possibleGearboxFiltersValues.torsionalBacklash)
      },
      productOrComponentType: []
      }
    };
    setData(newFilters.gearboxFilter);
  };

  const getGearBoxSize = (externalDiameter) => {
      return externalDiameter;
  }

  useUpdateEffect(() => {
      console.log("GearboxFilters data changed", data);
      console.log("Synchronized gearbox filters", synchronizedGearboxFilters);

      if (data) {
        // console.log("syncronize gearbox filters, data =>", data);
          updateGearboxFilters(data);

          const newFilters = {
            ...filters,
            gearboxFilter: {
            ...data,
            ratio: syncDataElementWithSynchronizedFiltersElement(synchronizedGearboxFilters?.reductionRatio, data?.ratio),
            externalDiameter: syncDataElementWithSynchronizedFiltersElement(synchronizedGearboxFilters?.externalDiameter, data?.externalDiameter),
            productOrComponentType: syncDataElementWithSynchronizedFiltersElement(synchronizedGearboxFilters?.productOrComponentType, data?.productOrComponentType),
          }
          };
          dispatch(setAxisFilters({ axisId, filters: newFilters }));
          setWithGearbox(withGearbox || data?.enabled);

      }
    }, [data]);

  return (
    <>
      <div className="GearboxFilters relative">
        <div
          className={`bg-gray-50 backdrop-blur-xs bg-opacity-50 h-full w-full top-0 left-0 absolute flex items-center justify-center z-20 ${
            !(isLoading || !data) && "hidden"
          }`}
        >
          <Spinner id="loading_spinner" />
        </div>
        <div className="md:flex justify-end hidden">
          <span
            onClick={handleClearFilters}
            className={`text-secondary text-sm px-2 py-1 cursor-pointer hover:underline select-none
              ${withGearbox ? "" : "invisible-element"}`}
          >
            {t("msizer.ui.filters.clear")}
          </span>
        </div>
        <div className="md:grid grid-cols-3 space-x-2 divide-x-2 divide-gray-100 divide-solid">
          <div className="p-2 space-y-5">
            {!isIntegratedDrivesConfiguration && <MotorFilters 
            filters={filters}
            filterToDisplay="gearboxToggle" gearboxFiltersProp={data}
            updateMotorFilters={updateGearboxFilters}
            axisId={axisId}
                                                 />}
            <div className={`space-y-5 ${!withGearbox ? "blur-sm pointer-events-none" : ""}`}>
              <LabelsPicker
                singleChoice
                label={t("msizer.ui.gearbox_filters.product_type")}
                required
                error={highlightErrors && (!data?.productOrComponentType || data?.productOrComponentType?.length === 0)}
                cols={2}
                options={[
                  // loop through all the possible values except null values
                  ...possibleGearboxFiltersValues.productOrComponentType
                    .filter((val) => val !== null)
                    .map((val) => ({
                      label: tData("gearbox", "product.component.type", val),
                      key: val
                    }))
                ]}
                selectedLabelsInit={data?.productOrComponentType}
                disabledLabels={possibleGearboxFiltersValues.productOrComponentType?.filter(
                  (val) => !synchronizedGearboxFilters?.productOrComponentType?.includes(val) || !synchronizedGearboxFilters
                )}
                onChange={(val) => {
                  // setFilterLaunchingSync({
                  //   productOrComponentType:
                  //     syncronizedFilters?.productOrComponentType
                  // });

                  setData({ ...data, productOrComponentType: val });
                }}
                changeWithInit
              />

              <LabelsPicker
                idLabel="ext-diameter"
                label={t("msizer.ui.gearbox_filters.external_diameter")}
                cols={4}
                selectedLabelsInit={getGearBoxSize(data?.externalDiameter)}
                options={possibleGearboxFiltersValues.externalDiameter
                  .filter((val) => val !== null)
                  ?.sort((a, b) => a - b)
                  .map((val) => ({
                    label: prettyPrint("externalDiameter", val),
                    key: val
                  }))}
                //.map((val) => ({ label: val, key: val }))}
                disabledLabels={possibleGearboxFiltersValues.externalDiameter.filter(
                  (val) => !synchronizedGearboxFilters?.externalDiameter?.includes(val) || !synchronizedGearboxFilters
                )}
                // selectedLabelsInit={data.family}
                onChange={(val) => {
                  setData({ ...data, externalDiameter: val });
                }}
                changeWithInit
              />
            </div>
          </div>
          <div className={`p-2 space-y-5 ${!withGearbox ? "blur-sm pointer-events-none" : ""}`}>
            <LabelsPicker
              idLabel="reduc-ratio"
              label={t("msizer.ui.gearbox_filters.reduction_ratio")}
              cols={3}
              options={[
                // loop through all the possible values except null values
                ...possibleGearboxFiltersValues.ratio
                  .filter((val) => val !== null)
                  ?.sort((a, b) => a - b)
                  .map((val) => ({ label: `${val}:1`, key: val }))
              ]}
              selectedLabelsInit={filters?.gearboxFilter?.ratio}
              // disabledLabels is possibleGearboxFiltersValues.ratio array minus
              // syncronizedFilters?.reductionRatio values
              // , or empty array if syncronizedFilters is null
              disabledLabels={possibleGearboxFiltersValues.ratio.filter(
                (val) =>  isIntegratedDrivesConfiguration? possibleGearboxFiltersValues.ratio : (!synchronizedGearboxFilters?.reductionRatio?.includes(val) || !synchronizedGearboxFilters)
              )}
              onChange={(val) => {
                console.log("Synchronized filters", synchronizedGearboxFilters);
                // setFilterLaunchingSync({
                //   reductionRatio: syncronizedFilters?.reductionRatio
                // });
                setData({ ...data, ratio: val });
              }}
              changeWithInit
            />
          </div>
          <div className={`p-2 space-y-5 ${!withGearbox ? "blur-sm pointer-events-none" : ""}`}>
            <SelectionRange
              label={t("msizer.ui.gearbox_filters.maximum_torsional_backlash")}
              min={0}
              // max={Math.max(
              //   ...possibleGearboxFiltersValues.torsionalBacklash
              // )}
              possibleMin={0}
              max={
                synchronizedGearboxFilters?.torsionalBacklash?.max
                // || Math.max(...possibleGearboxFiltersValues.torsionalBacklash)
              }
              possibleMax={synchronizedGearboxFilters?.torsionalBacklash?.max}
              maxSmallestValue={
                synchronizedGearboxFilters?.torsionalBacklash?.min
                // || Math.min(...possibleGearboxFiltersValues.torsionalBacklash)
              }
              step={1}
              minValueInit={data?.torsionalBacklash?.min}
              maxValueInit={data?.torsionalBacklash?.max}
              onChange={(min, max) => {
                setData({
                  ...data,
                  torsionalBacklash: { min: 0, max }
                });
              }}
              changeWithInit
              minimumLocked
            />
          </div>
        </div>
      </div>
      <div className="flex justify-center space-x-2 pt-2">
        <div className="flex-1 px-2" />
        <div className="flex-1 px-2 flex gap-2 md:gap-0 justify-center">
          <qds-button
            id="select-filters-button-apply"
            {...(withGearbox && (!data?.productOrComponentType || data?.productOrComponentType?.length === 0) ? { disabled: "" } : {})}
            onClick={handleApplyFilters}
            text={t("msizer.ui.popup.button.apply")}
          >
            
          </qds-button>
          <Button onClick={handleClearFilters} border="blue" textColor="blue" large classes="md:hidden">
            {t("msizer.ui.filters.clear")}
          </Button>
        </div>
        <div className="flex-1 px-2" />
      </div>
    </>
  );
};

GearboxFilters.propTypes = {
  closeTab: PropTypes.func
};

GearboxFilters.defaultProps = {
  closeTab: () => {}
};

export default GearboxFilters;